import React, { PureComponent } from 'react'
import { reduxForm, reset } from 'redux-form'
import { Button } from 'react-bootstrap'
import { getSectionPermissions } from '../../util/permisionFunctions'
import { sectionPermissions } from '../../constants/dossier/common/buttonsHeader'
import { unattendedResult } from '../../constants/management/unattendedStatus'
import AuditAdminPage from '../../containers/management/AuditAdminPage'
import AuditsPage from '../../containers/management/AuditsPage'
import SearchDocumentalPage from '../../containers/management/SearchDocumentalPage'
import { managementTab, managementTabCode } from '../../constants/management/managementConstants'
import AuditModalPage from '../../containers/management/Modals/AuditModalPage'
import SimpleInputText from '../../components/commons/simpleForm/SimpleInputText'
import { permissions } from '../../constants/backendIds'

import MapSections from '../../util/map-sections_v2'
import MapSectionsManagement from '../../util/map-sections-management'
import FleetsPage from '../../containers/management/FleetsPage'
import FleetFinderPage from '../../containers/management/FleetFinderPage'
import UnattendedProcessesFinderPage from '../../containers/management/UnattendedProcessesFinderPage'
import FleetsManagerPage from '../../containers/management/FleetsManagerPage'
import SelfSupplyManagementPage from '../../containers/management/SelfSupplyManagementPage'
import SearchByChargeFormPage from '../../containers/management/SearchByChargeFormPage'
import SearchByPrepareFormPage from '../../containers/management/SearchByPrepareFormPage'
import SearchByPapFormPage from '../../containers/management/SearchByPapFormPage'
import SearchByPlanLogisticsPapFormPage from '../../containers/management/SearchByPlanLogisticsPapFormPage'
import SearchByFleetsFormPage from '../../containers/management/SearchByFleetsFormPage'

class Management extends PureComponent {
  constructor () {
    super()
    this.state = {
      secMapManagement: MapSectionsManagement,
      sectionTabsConfiguration: {
        fleets: {
          permission: null
        },
        fleetsManagement: {
          permission: null
        },
        unattendedProcess: {
          permission: null
        },
        fleet_management_section: {
          permission: null
        },
        self_supply_section: {
          permission: null
        },
        audit_admin: {
          permission: null
        },
        audits: {
          permission: null
        },
        search_documental: {
          permission: null
        },
        papServicesManager: {
          permission: null
        },
        hideMenu: false
      },
      processSearched: false,
      processfields: {
        unattendedProcessStatus: [unattendedResult.PENDING, unattendedResult.RUNNING_NO_ERRORS],
        unattendedProcessView: 1
      },
      visible: false,
      sectionFilter: '',
      // from search page
      dossierIdToArray: [],
      fields: {}
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.auditAdminModal.showModal === false && prevProps.auditAdminModal.showModal === true) {
      this.setState({ visible: false })
    }
    if (!this.props.selectedTabManagement) {
      this.getDefaultSelectedTab()
    } else {
      const section = this.state.secMapManagement.find(item => item.code === this.getTabByNumber(this.props.selectedTabManagement))
      if (section.active === false) {
        this.selectSection(section, this.props.selectedTabManagement === prevProps.selectedTabManagement)
      }
    }
  }

  componentDidMount () {
    this.initializePermisions(this.props)
  }

  initializePermisions (props) {
    const section = props.sectionsGeneral.filter((tabConf) => tabConf.code === sectionPermissions.management)
    if (section.length > 0 && section[0] != null) {
      const newState = getSectionPermissions(section[0])
      let visibleSectionConfiguration = []
      this.state.secMapManagement.forEach(function (item) {
        var permissionCode = newState[item.code]
        if (permissionCode !== undefined && permissionCode.permission !== null && permissionCode.permission > permissions.hidden) {
          item.active = false
          item.sectionFieldsConfiguration = permissionCode.sectionFieldsConfiguration
          visibleSectionConfiguration.push(item)
        }
      })
      visibleSectionConfiguration[0].active = true
      this.setState({ secMapManagement: visibleSectionConfiguration })
    }
  }

  getDefaultSelectedTab () {
    let firstTabToShow = null
    Object.keys(this.state.sectionTabsConfiguration).forEach(tab => {
      if (!firstTabToShow && this.state.sectionTabsConfiguration[tab] && this.state.sectionTabsConfiguration[tab].permission > permissions.hidden) {
        firstTabToShow = this.getTabByCode(tab)
      }
    })
    if (firstTabToShow) {
      this.props.actions.managementTabChange(firstTabToShow)
    }
  }

  getTabByCode (code) {
    switch (code) {
      case managementTabCode.FLEETS: {
        return managementTab.FLEETS
      } case managementTabCode.FLEETS_MANAGEMENT: {
        return managementTab.FLEETS_MANAGEMENT
      } case managementTabCode.UNATTENDED_PROCESS: {
        return managementTab.UNATTENDED_PROCESS
      } case managementTabCode.FLEETS_MANAGEMENT_SECTION: {
        return managementTab.FLEETS_MANAGEMENT_SECTION
      } case managementTabCode.SELF_SUPPLT_SECTION: {
        return managementTab.SELF_SUPPLT_SECTION
      } case managementTabCode.CHARGE: {
        return managementTab.CHARGE
      } case managementTabCode.PREPARE: {
        return managementTab.PREPARE
      } case managementTabCode.PAP_SERVICES_MANAGER: {
        return managementTab.PAP_SERVICES_MANAGER
      } case managementTabCode.ADMIN_AUDIT: {
        return managementTab.ADMIN_AUDIT
      } case managementTabCode.ADMIN_AUDITS: {
        return managementTab.ADMIN_AUDITS
      } case managementTabCode.SEARCH_DOCUMENTAL: {
        return managementTab.SEARCH_DOCUMENTAL
      } case managementTabCode.PLAN_LOGISTICS_PAP: {
        return managementTab.PLAN_LOGISTICS_PAP
      } case managementTabCode.FLEETS_SEARCH: {
        return managementTab.FLEETS_SEARCH
      }
    }
    return null
  }

  getTabByNumber (number) {
    switch (number) {
      case managementTab.FLEETS: {
        return managementTabCode.FLEETS
      } case managementTab.FLEETS_MANAGEMENT: {
        return managementTabCode.FLEETS_MANAGEMENT
      } case managementTab.UNATTENDED_PROCESS: {
        return managementTabCode.UNATTENDED_PROCESS
      } case managementTab.FLEETS_MANAGEMENT_SECTION: {
        return managementTabCode.FLEETS_MANAGEMENT_SECTION
      } case managementTab.SELF_SUPPLT_SECTION: {
        return managementTabCode.SELF_SUPPLT_SECTION
      } case managementTab.CHARGE: {
        return managementTabCode.CHARGE
      } case managementTab.PREPARE: {
        return managementTabCode.PREPARE
      } case managementTab.PAP_SERVICES_MANAGER: {
        return managementTabCode.PAP_SERVICES_MANAGER
      } case managementTab.ADMIN_AUDIT: {
        return managementTabCode.ADMIN_AUDIT
      } case managementTab.ADMIN_AUDITS: {
        return managementTabCode.ADMIN_AUDITS
      } case managementTab.SEARCH_DOCUMENTAL: {
        return managementTabCode.SEARCH_DOCUMENTAL
      } case managementTab.PLAN_LOGISTICS_PAP: {
        return managementTabCode.PLAN_LOGISTICS_PAP
      } case managementTab.FLEETS_SEARCH: {
        return managementTabCode.FLEETS_SEARCH
      }
    }
    return null
  }

  openAuditAdminModal () {
    this.setState({
      visible: true
    }, () => {
      const auditConfiguration = {
        AuditObservation: false,
        audit: false
      }
      this.props.actions.openAuditAdminModal(auditConfiguration)
    })
  }

  toogleInnerMenu () {
    this.setState({ hideMenu: !this.state.hideMenu })
  }

  filterSections (t) {
    let nameFilter = this.state.sectionFilter
    let secMapManagement = this.props.secMapManagement ?? this.state.secMapManagement

    if (!this.state.sectionFilter) {
      return secMapManagement
    }
    let filtered = secMapManagement.filter(function (item) {
      return t(item.title).toUpperCase().includes(nameFilter.toUpperCase())
    })
    return filtered
  }

  selectSection (item, sameSection) {
    let visibleSectionConfiguration = []
    this.state.secMapManagement.forEach(element => {
      element.active = element.code === item.code
      visibleSectionConfiguration.push(element)
    })

    this.props.actions.managementSectionChangeSuccess(visibleSectionConfiguration)
    this.props.actions.managementTabChange(this.getTabByCode(item.code))
    if (!sameSection) {
      this.props.actions.resetFilters()
    }
    this.props.dispatch(reset('fleetsManager'))
  }

  fieldFill (field) {
    this.setState({ fields: { ...this.state.fields, ...field } })
  }

  render () {
    const {
      t, selectedTabManagement,
      showButtonUploadDocument, pages, count, hasSearch, chargeData, papServicesData, dossierData, vehicleData, prepareData, serviceRoleConfig, filters: { page } // props de la sección de buscadores
    } = this.props
    const secMap = MapSections.management
    const tKey = 'MANAGEMENT.'
    const showButton = selectedTabManagement === managementTab.ADMIN_AUDIT
    const availableSections = this.filterSections(t)
    const selectedSection = availableSections.filter(x => x.active === true)[0]
    const className = 'filled'
    const classNameSelect = 'filledSelect'

    return (
      <div className="wrapper _nf">
        <div className='wrapper-header'>
          <div className="title-page">
            <i className={secMap.icon + ' icon-page'} />
            <h2>{t(`${secMap.title}`)}</h2>
          </div>
          <div className='title-page-extra'>
            {showButton && (
              <Button id="btn_delete" className="_Btn new" onClick={() => this.openAuditAdminModal()}><i className="iDocIcon-add-plus"></i>{t(`${tKey}NEW_AUDIT`)}</Button>
            )}
          </div>
        </div>
        <div className='wrapper-body'>
          <div className={this.state.hideMenu ? 'inner-menu-content innerMenuHide' : 'inner-menu-content'}>
            <div className='inner-menu-helpers'>
              <SimpleInputText
                componentClass = 'search-box'
                colWidth={100}
                placeholder = {t('SECTIONS.FILTER')}
                value={this.state.sectionFilter}
                onInputChange={sectionFilter => this.setState({ sectionFilter })}
              />
            </div>
            <ul className='inner-items'>
              {
                availableSections.map((item, idx) => {
                  return (
                    <li key={idx} className={ item.active === true ? 'active' : ''}><p onClick={() => this.selectSection(item)}>{t(`${item.title}`)}</p></li>
                  )
                })
              }
            </ul>
          </div>
          <div className='inner-data-content'>

            {selectedSection !== undefined && selectedSection.page === 'fleetsPage' &&
                <FleetsPage
                  tabId = {1}
                  toogleInnerMenu={() => this.toogleInnerMenu()}
                  hideMenu={this.state.hideMenu}
                  fetchManagementActions = {this.props.actions.fetchManagementActions}
                  managementActions = {this.props.combos.managementActions}
                  sectionsGeneral = {this.props.sectionsGeneral}
                ></FleetsPage>}

            {selectedSection !== undefined && selectedSection.page === 'fleetFinderPage' &&
                <FleetFinderPage
                  toogleInnerMenu={() => this.toogleInnerMenu()}
                  hideMenu={this.state.hideMenu}>
                </FleetFinderPage>}

            {selectedSection !== undefined && selectedSection.page === 'unattendedProcessesFinderPage' &&
                <UnattendedProcessesFinderPage
                  toogleInnerMenu={() => this.toogleInnerMenu()}
                  hideMenu={this.state.hideMenu}>
                </UnattendedProcessesFinderPage>}

            {selectedSection !== undefined && selectedSection.page === 'fleetsManagerPage' &&
                <FleetsManagerPage
                  sectionsGeneral = {this.props.sectionsGeneral}
                  toogleInnerMenu={() => this.toogleInnerMenu()}
                  hideMenu={this.state.hideMenu}
                >

                </FleetsManagerPage> }

            {selectedSection !== undefined && selectedSection.page === 'selfSupplyManagementPage' &&
                <SelfSupplyManagementPage
                  selectedTabManagement = {selectedTabManagement}
                  toogleInnerMenu={() => this.toogleInnerMenu()}
                  hideMenu={this.state.hideMenu}>
                </SelfSupplyManagementPage>}

            {selectedSection !== undefined && selectedSection.page === 'auditAdminPage' &&
                    <AuditAdminPage
                      selectedTabManagement = {selectedTabManagement}
                      toogleInnerMenu={() => this.toogleInnerMenu()}
                      hideMenu={this.state.hideMenu}>
                    </AuditAdminPage>}

            {selectedSection !== undefined && selectedSection.page === 'auditsPage' &&
                    <AuditsPage
                      selectedTabManagement = {selectedTabManagement}
                      toogleInnerMenu={() => this.toogleInnerMenu()}
                      hideMenu={this.state.hideMenu}>
                    </AuditsPage>}

            {selectedSection !== undefined && selectedSection.page === 'searchDocumentalPage' &&
                    <SearchDocumentalPage
                      selectedTabManagement = {selectedTabManagement}
                      toogleInnerMenu={() => this.toogleInnerMenu()}
                      hideMenu={this.state.hideMenu}>
                    </SearchDocumentalPage>}

            {/* // COBROS */}
            {selectedSection !== undefined && selectedSection.page === 'searchCharge' &&
                <SearchByChargeFormPage
                  t={t}
                  change={this.props.change}
                  fields={this.state.fields}
                  organizedUnitId={''}
                  fieldFill={(val) => this.fieldFill(val)}
                  className={className}
                  classNameSelect={classNameSelect}
                  hasSearch={hasSearch}
                  chargeData={chargeData}
                  permissions = {this.state.sectionTabsConfiguration.charge && this.state.sectionTabsConfiguration.charge && this.state.sectionTabsConfiguration.charge.sectionFieldsConfiguration ? this.state.sectionTabsConfiguration.charge.sectionFieldsConfiguration : null }
                  toogleInnerMenu={() => this.toogleInnerMenu()}
                  hideMenu={this.state.hideMenu}
                />}

            {/* GESTION DE PREPARACIONES */}
            {selectedSection !== undefined && selectedSection.page === 'searchByPAP' &&
              <SearchByPrepareFormPage
                t={t}
                change={this.props.change}
                prepareData = {prepareData}
                serviceRoleConfig = {serviceRoleConfig}
                fields={this.state.fields}
                fieldFill={(val) => this.fieldFill(val)}
                className={className}
                classNameSelect={classNameSelect}
                hasSearch={hasSearch}
                permissions={this.state.sectionTabsConfiguration.prepare && this.state.sectionTabsConfiguration.prepare.sectionFieldsConfiguration ? this.state.sectionTabsConfiguration.prepare.sectionFieldsConfiguration : null}
                fetchServicePrepareRoleConfig = {this.props.actions.fetchServicePrepareRoleConfig}
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />}
            {/* GESTION MASIVA DE CAMPA */}
            {selectedSection !== undefined && selectedSection.page === 'searchByPapServices' &&
              <SearchByPapFormPage
                t={t}
                change={this.props.change}
                fields={this.state.fields}
                organizedUnitId={''}
                fieldFill={(val) => this.fieldFill(val)}
                className={className}
                classNameSelect={classNameSelect}
                hasSearch={hasSearch}
                dossierData={papServicesData}
                page={page}
                pages={pages}
                count={count}
                permissions = {this.state.secMapManagement && this.state.secMapManagement.filter(x => x.page === 'searchByPapServices') ? this.state.secMapManagement.filter(x => x.page === 'searchByPapServices')[0] : null }
                toogleInnerMenu={() => this.toogleInnerMenu()}
                hideMenu={this.state.hideMenu}
              />}
            {/* PLANIFICAR PAP LOGISTICA */}
            {selectedSection !== undefined && selectedSection.page === 'searchsPlanLogisticsPap' &&
              <SearchByPlanLogisticsPapFormPage
                t={t}
                change={this.props.change}
                fields={this.state.fields}
                organizedUnitId={''}
                fieldFill={(val) => this.fieldFill(val)}
                className={className}
                classNameSelect={classNameSelect}
                hasSearch={hasSearch}
                dossierData={papServicesData}
                page={page}
                pages={pages}
                count={count}
                toogleInnerMenu={() => this.toogleInnerMenu()}
                openModal ={this.props.actions.openModal}
              />}

            {/* ANTIGUA SECCION FLOTAS DEL BUSCADOR (SE DENOMINARÁ DOCUMENTACION FLOTAS) */}
            {selectedSection !== undefined && selectedSection.page === 'searchByFleets' &&
              <SearchByFleetsFormPage
                t={t}
                change={this.props.change}
                fields={this.state.fields}
                organizedUnitId={''}
                fieldFill={(val) => this.fieldFill(val)}
                className={className}
                classNameSelect={classNameSelect}
                hasSearch={hasSearch}
                dossierData={dossierData}
                vehicleData={vehicleData}
                toogleInnerMenu={() => this.toogleInnerMenu()}
                page={page}
                pages={pages}
                count={count}
                showButtonUploadDocument = {showButtonUploadDocument}
              />
            }

            { this.state.visible &&
              <AuditModalPage
                readOnly={false}
                isAdmin={true}
              />
            }
          </div>
        </div>

      </div>
    )
  }
}

export default reduxForm({
  form: 'management'
})(Management)
